import styled from "styled-components";

export const ProjectComponentStyled = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 40px;
  padding-top: 20px;
  width: 100%;

  h4 {
    padding-top: 10px;
    width: 25%;
  }
  div {
    padding-bottom: 5px;
    width: 75%;
  }
  .desc {
    margin-bottom: 20px;
    display: flex;
  }
  a {
    padding: 10px;
    border: 2px solid tomato;
    transition: transform 500ms cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  a:hover {
    transform: scale(1.1);
  }
`;
